import { AccountAvailableCash } from '../type';

export const hasAvailableLiquidities = (lines: AccountAvailableCash[] | undefined) => (lines ? lines.filter((line) => line['C_CURRENCY.QT'] > 0).length > 0 : false);
